import { Link, styled } from "@mui/material";
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

const StyledLink = styled(Link)`
  position: absolute;
  left: -9999px;
  top: ${(props) => props.theme.spacing(1)};
  z-index: 999;
  padding: ${(props) => props.theme.spacing(1)} ${(props) => props.theme.spacing(2)};
  background-color: ${(props) => props.theme.palette.primary.contrastText};
  color: ${(props) => props.theme.palette.primary.main};
  text-decoration: none;

  &:focus {
    left: ${(props) => props.theme.spacing(1)};
    outline: 2px solid ${(props) => props.theme.palette.primary.main};
  }
`;

export const SkipLink = () => {
  const location = useLocation();

  useEffect(() => {
    if (document.activeElement && document.activeElement !== document.body) {
      (document.activeElement as HTMLElement).blur();
    }
    document.body.setAttribute("tabindex", "-1");
    document.body.focus();
    document.body.removeAttribute("tabindex");
  }, [location]);

  return <StyledLink href="#main">Sauter directement au contenu principal</StyledLink>;
};
